<!-- 
    <div>
    <form [formGroup]="filterForm">
        <div class="tools">
            <div *ngIf="areas" class=" ">
                <mat-form-field *ngIf="areas.length > 1" appearance="outline" class="full-width">
                    <mat-label>Filtrar materias</mat-label>
                    <mat-select formControlName="materias" multiple>
                        <mat-option *ngFor="let area of areas" [value]="area.id">{{area.nombre}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="toolx1">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Mostrar evidencias</mat-label>
                    <mat-select formControlName="evidenciasControl" multiple>
                        <mat-option *ngFor="let tipo of _tiposEvidencias" [value]="tipo.id">{{tipo.nombre}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </form>
</div> 
-->
<section class="unidad-evidencias-container">
    <div class="categoria">
        <h3 class="mat-h2">Evidencias <span class="mat-h5">({{evidencias.length}})</span></h3>
        <ng-container *ngFor="let evidencia of evidencias">
            <unidad-evento [alumnoId]="alumnoId" [eventoUnidad]="evidencia" (eliminar)="eliminarEvento($event)"
            [showResumenStatus]="false" [isFamilia]="isFamilia" [unidad]="_unidad"></unidad-evento>
        </ng-container>
    </div>

</section>
